import { useReveal } from "../hooks/useReveal";
import { Nav } from "../components/sections/Nav";
import { Hero } from "../components/sections/Hero";
import { AtAGlance } from "../components/sections/AtAGlance";
import { About } from "../components/sections/About";
import { Timeline } from "../components/sections/Timeline";
import { Impact } from "../components/sections/Impact";
import { Clients } from "../components/sections/Clients";
import { Campaigns } from "../components/sections/Campaigns";
import { Skills } from "../components/sections/Skills";
import { Promotions } from "../components/sections/Promotions";
import { WhatsNext } from "../components/sections/WhatsNext";
import { Footer } from "../components/sections/Footer";

export default function Home() {
  useReveal();
  return (
    <div data-testid="home-page" className="min-h-screen">
      <Nav />
      <main>
        <Hero />
        <AtAGlance />
        <About />
        <Timeline />
        <Impact />
        <Clients />
        <Campaigns />
        <Skills />
        <Promotions />
        <WhatsNext />
      </main>
      <Footer />
    </div>
  );
}
